"use client";

import { Card, CardContent } from "@/components/ui/card";
import { Search, Settings, Zap, CircleCheckBig } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FourStepMethod() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15
  });
  const steps = [{
    id: 1,
    icon: Search,
    title: "Inspección inicial",
    description: "Analizamos la superficie para evaluar las necesidades específicas del servicio, garantizando una limpieza segura y adaptada a cada cliente."
  }, {
    id: 2,
    icon: Settings,
    title: "Planificación y parámetros",
    description: "Definimos el plan de limpieza personalizado, ajustando presión, distancia y técnica según el tipo de superficie y nivel de suciedad."
  }, {
    id: 3,
    icon: Zap,
    title: "Limpieza con drones",
    description: "Nuestros drones especializados ejecutan la limpieza con precisión milimétrica, alcanzando zonas inaccesibles sin riesgos para el personal con gran velocidad y eficacia."
  }, {
    id: 4,
    icon: CircleCheckBig,
    title: "Resultados visibles",
    description: "Entregamos superficies impecables con documentación visual detallada del antes y después, asegurando transparencia y garantizando la máxima satisfacción."
  }];
  return <section ref={ref} className="bg-dark-background py-16 px-6 md:py-24">
      <div className="mx-auto max-w-5xl">
        <div className="mb-12 text-center">
          <h2 className="font-display text-3xl font-bold text-white md:text-4xl">Nuestro método</h2>
          <p className="mt-4 text-lg text-white">Un proceso que garantiza resultados rápidos, ecológicos, seguros y sin riesgo humano</p>
        </div>

        <div className="grid gap-6">
          {steps.map((step, i) => {
          const Icon = step.icon;
          return <Card key={step.id} data-index={i} className={`border border-muted/20 bg-background/5 backdrop-blur-sm transition-all duration-300 hover:bg-background/10 hover:shadow-strong ${isVisible ? i === 0 ? "animate-fade-in-up" : i === 1 ? "animate-fade-in-up-delay-100" : "animate-fade-in-up-delay-200" : "opacity-0"}`} style={{
            animationDelay: isVisible ? `${i * 150}ms` : "0ms"
          }}>
                <CardContent className="flex flex-col gap-6 p-6 md:flex-row md:gap-8">
                  <div className="flex flex-shrink-0 items-start justify-center md:w-[30%]">
                    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/20">
                      <Icon className="h-8 w-8 text-primary" strokeWidth={2} />
                    </div>
                  </div>

                  <div className="flex flex-col justify-center md:w-[70%]">
                    <h3 className="mb-2 font-display text-xl font-semibold text-white">
                      {step.title}
                    </h3>
                    <p className="text-white">
                      {step.description}
                    </p>
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}